/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

import { useColorModeValue } from '@chakra-ui/color-mode'

import { bgDark, bgLight, colorDark, colorLight } from '../z4/constants'

export const useBodyColor = () => {
  const bgColor = useColorModeValue(bgLight, bgDark)
  const textColor = useColorModeValue(colorLight, colorDark)
  return { bgColor, textColor }
}
